import { useEffect, type ReactNode } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useClientSelection } from '../../contexts/ClientSelectionContext';

/**
 * The decision email links to /retours/decisions/:id?clientId=<store>. Before the page (and
 * ClientGate's « choose a store » prompt) renders, a multi-store user or an admin switches to
 * that store — otherwise the hold would read « introuvable » under another one. Only a store
 * this user can already pick; the server still enforces the tenant.
 */
export default function LinkStore({ children }: { children: ReactNode }) {
  const [params] = useSearchParams();
  const { effectiveClientId, clients, setSelectedClientId } = useClientSelection();
  const linkClient = params.get('clientId') || '';
  const switchTo = linkClient && linkClient !== effectiveClientId && clients.some((c) => c.id === linkClient) ? linkClient : null;
  useEffect(() => { if (switchTo) setSelectedClientId(switchTo); }, [switchTo, setSelectedClientId]);
  return switchTo ? null : <>{children}</>;
}
